if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.galleryMql = window.matchMedia('(hover: hover) and (min-width: 750px)');
        this.slides = [];
        this.currentIndex = 0;
        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        this.counter = this.querySelector('.product-media-modal__counter');

        this.addEventListener('pointerup', this.onGalleryPointerUp.bind(this), { capture: true });
        this.addEventListener('click', this.onGalleryClick.bind(this));
        this.addEventListener('keyup', this.onGalleryKeyUp.bind(this));
        this.addEventListener('mousemove', this.onGalleryMouseMove.bind(this));
        this.addEventListener('dragstart', (event) => {
          if (this.isGallery()) event.preventDefault();
        });
      }

      hide() {
        this.resetZoom();
        this.classList.remove('product-media-modal--gallery', 'product-media-modal--single');
        super.hide();
      }

      show(opener) {
        super.show(opener);
        if (this.galleryMql.matches) {
          this.showGallery();
        } else {
          this.showActiveMedia();
        }
      }

      isGallery() {
        return this.classList.contains('product-media-modal--gallery');
      }

      showGallery() {
        this.slides = this.getGallerySlides();
        if (!this.slides.length) return this.showActiveMedia();

        const openedMediaId = this.openedBy.getAttribute('data-media-id');
        const openedIndex = this.slides.findIndex((slide) => slide.dataset.mediaId === openedMediaId);

        this.classList.add('product-media-modal--gallery');
        this.classList.toggle('product-media-modal--single', this.slides.length < 2);
        this.goTo(Math.max(openedIndex, 0));
      }

      getGallerySlides() {
        const sectionId = this.id.replace('ProductModal-', '');
        const content = this.querySelector('.product-media-modal__content');
        const pageItems = document.querySelectorAll(`#Slider-Gallery-${sectionId} li[data-media-id]`);

        const slides = Array.from(pageItems)
          .filter((item) => item.getClientRects().length)
          .map((item) => {
            const mediaId = item.dataset.mediaId.replace(`${sectionId}-`, '');
            return content.querySelector(`:scope > [data-media-id="${mediaId}"]`);
          })
          .filter(Boolean);

        return slides.length ? slides : Array.from(content.querySelectorAll(':scope > [data-media-id]'));
      }

      goTo(index) {
        if (index < 0 || index >= this.slides.length) return;

        this.resetZoom();
        this.currentIndex = index;
        this.querySelectorAll('.product-media-modal__content > .active').forEach((element) => {
          element.classList.remove('active');
        });
        this.slides[index].classList.add('active');

        const focusedNav = document.activeElement?.closest?.('.product-media-modal__nav');
        this.counter.textContent = `${index + 1} / ${this.slides.length}`;
        this.prevButton.disabled = index === 0;
        this.nextButton.disabled = index === this.slides.length - 1;

        if (focusedNav?.disabled) this.querySelector('[role="dialog"]').focus();
      }

      onGalleryPointerUp(event) {
        if (this.isGallery() && !event.target.closest('deferred-media, product-model')) event.stopImmediatePropagation();
      }

      onGalleryClick(event) {
        if (!this.isGallery()) return;

        if (this.prevButton.contains(event.target)) return this.goTo(this.currentIndex - 1);
        if (this.nextButton.contains(event.target)) return this.goTo(this.currentIndex + 1);
        if (event.target.closest('button')) return;

        const activeSlide = this.slides[this.currentIndex];
        if (activeSlide.tagName === 'IMG') this.toggleZoom(activeSlide, event);
      }

      onGalleryKeyUp(event) {
        if (!this.isGallery() || event.target.closest('deferred-media, product-model')) return;

        if (event.key === 'ArrowLeft') this.goTo(this.currentIndex - 1);
        if (event.key === 'ArrowRight') this.goTo(this.currentIndex + 1);
      }

      toggleZoom(image, event) {
        if (image.classList.contains('is-zoomed')) return this.resetZoom();

        this.zoomRect = image.getBoundingClientRect();
        this.zoomedImage = image;
        this.moveZoom(event);
        image.classList.add('is-zoomed');
      }

      onGalleryMouseMove(event) {
        if (this.zoomedImage) this.moveZoom(event);
      }

      moveZoom(event) {
        const { left, top, width, height } = this.zoomRect;
        const xPercent = Math.min(Math.max(((event.clientX - left) / width) * 100, 0), 100);
        const yPercent = Math.min(Math.max(((event.clientY - top) / height) * 100, 0), 100);
        this.zoomedImage.style.transformOrigin = `${xPercent}% ${yPercent}%`;
      }

      resetZoom() {
        if (!this.zoomedImage) return;

        this.zoomedImage.classList.remove('is-zoomed');
        this.zoomedImage = null;
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
